module.exports = __webpack_public_path__ + "static/media/reviews_menu_active.b5991ff0.svg";